import { Nullable } from '@kts-front/types';
import { Flex, FlexProps, MantineSize, NumberFormatter } from '@mantine/core';
import * as React from 'react';

import Text from 'components/shared/Text';

type Props = FlexProps & {
  label: string;
  valueString?: Nullable<string>;
  valueNumber?: Nullable<string>;
  valueSize?: MantineSize;
  valueFw?: string;
};

const FieldTextAndValue: React.FC<Props> = ({
  label,
  valueString,
  valueNumber,
  valueSize = 'md',
  valueFw = 400,
  ...props
}) => {
  return (
    <Flex gap="xxxs" direction="column" {...props}>
      <Text size="sm" c="gray.6">
        {label}
      </Text>
      <Text size={valueSize} fw={valueFw}>
        {valueString && valueString}
        {valueNumber && <NumberFormatter value={valueNumber} thousandSeparator="&nbsp;" suffix="&nbsp;₽" />}
      </Text>
    </Flex>
  );
};

export default FieldTextAndValue;
